import { render } from "./LicenseManagement.vue?vue&type=template&id=3949a270&scoped=true"
import script from "./LicenseManagement.vue?vue&type=script&lang=js"
export * from "./LicenseManagement.vue?vue&type=script&lang=js"

import "./LicenseManagement.vue?vue&type=style&index=0&id=3949a270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3949a270"]])

export default __exports__